"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIGMA_LINK = exports.IP_NOTIFICATION_AUTO_HIDE_DURATION = exports.IP_NOTIFICATION_MAX_SNACK = exports.PREFIX = void 0;
var global_config_constants_scss_1 = __importDefault(require("./global.config.constants.scss"));
exports.PREFIX = global_config_constants_scss_1.default.prfx;
/** The default maximum number of notifications that can be stacked on top of one another. */
exports.IP_NOTIFICATION_MAX_SNACK = 5;
/** The default number of milliseconds to wait before automatically calling the `onClose` function for notifications. */
exports.IP_NOTIFICATION_AUTO_HIDE_DURATION = 2500;
/** Link for Figma with design */
exports.FIGMA_LINK = 'https://www.figma.com/file/VpIZdww6ME1bGx31KdcpGw/Design-System';
